<app-carousel (changeSlide)="onChangeSlide($event)">
  <app-carousel-slide *ngFor="let ListOfImage of arrayListImage">
    <img class="rounded-3xl max-w-none mt-3 mb-5" src="{{ ListOfImage.src }}" />
  </app-carousel-slide>
</app-carousel>
